module["exports"] = [
  "Schweiz"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/address/default_country.js
// module id = 877
// module chunks = 0